<!-- src/views/AboutView.vue -->
<template>
  <div class="page-wrapper">
    <div class="page-card">
      <h1>?? 关于我们</h1>
      <p>我们专注于提供简洁、高效的优毕学社解决方案。本系统实现了二级菜单功能，让作品分类更加清晰有序。</p>
      <h2>?? 设计理念</h2>
      <ul>
        <li>清晰的分类层级：主菜单+二级子菜单</li>
        <li>多端适配：PC端下拉菜单，移动端折叠面板</li>
        <li>用户体验优先：直观的交互方式</li>
      </ul>
      <div class="badge">关于我们 · 专注优毕学社</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AboutView'
};
</script>

<style scoped>
.page-wrapper {
  min-height: 100vh;
  background: #f8fafc;
  padding: 2rem;
}

.page-card {
  background: white;
  border-radius: 1.5rem;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.05);
  padding: 2rem;
  max-width: 1100px;
  margin: 0 auto;
}

h1 {
  font-size: 2rem;
  font-weight: 700;
  margin-bottom: 1rem;
  color: #0c4a6e;
}

h2 {
  font-size: 1.3rem;
  margin: 1.5rem 0 0.8rem;
  color: #1e293b;
  border-left: 4px solid #3b82f6;
  padding-left: 1rem;
}

p {
  color: #334155;
  margin-bottom: 1rem;
  line-height: 1.6;
}

ul {
  margin-left: 1.5rem;
  color: #2c3e50;
}

li {
  margin: 0.5rem 0;
}

.badge {
  display: inline-block;
  background: #eef2ff;
  color: #1e40af;
  border-radius: 30px;
  padding: 0.3rem 1rem;
  font-size: 0.8rem;
  margin-top: 1.5rem;
}
</style>